<template>
  <div id="settingsCoach">
    <PlatformSettings />

    <!-- <CalendarSettings v-if="platform !== 'ING'" /> -->
    <CalendarSettings />
  </div>
</template>

<script>
import CalendarSettings from './widgets/coach/CalendarSettings.vue';

export default {
  components: {
    CalendarSettings,
  },

  data: () => ({ }),

  computed: {
    platform() {
      // TMP Solution: need to remove when calendar settings will move to CAS
      return process.env.VUE_APP_PLATFORM;
    },
  },

  beforeCreate() {
    // Dynamically load components
    if (process.env.VUE_APP_COMPONENT_COACH_PLATFORM_SETTINGS) {
      this.$options.components.PlatformSettings = () => import(
        /* webpackChunkName: "custom-coach" */ process.env.VUE_APP_COMPONENT_COACH_PLATFORM_SETTINGS
      );
    } else {
      this.$options.components.PlatformSettings = () => import(
        /* webpackChunkName: "dashboard-coach" */ './widgets/coach/PlatformSettings.vue'
      );
    }
  },
};
</script>

<style lang="scss" scoped>
  #settingsCoach {
    .el-card {
      margin-bottom: 20px;
    }
  }
</style>
